.root {
  display: flex;
  flex-shrink: 0;
}

.menuPaper {
  width: 242px;
  margin-top: 8px;
  padding: 0;
}
